export default "__VITE_ASSET__FL0FpvxZ__"